import React from 'react';

import './style.css';

const PageTitle = ({ children }) => {
  return <>{children}</>;
};

export default PageTitle;
